export default __webpack_public_path__ + "static/media/Events.125fdef6.svg";